<template>
  <div class="setCompanyInformation">
    <div :class="bianll == true ? 'gain' : 'no_gain'">
      <!-- 设置的头部信息 -->
      <div class="inforHead">
        <div class="inforLogo">
          <div class="topLogo"></div>
          <div class="bottomLogo"></div>
        </div>
        <div class="inforText">
          <p class="onlyOneStep">还差一步就可以开始体验会话存档啦</p>
          <p class="detail">
            为保证正常体验会话内容存档全部功能，请先完成以下配置后使用，在配置过程中遇到问题可以联系客服400-113-0200
          </p>
        </div>
      </div>
      <!-- 设置的内容部分信息 -->
      <div class="setContent">
        <div class="archiveParams">
          <p class="archiveTitle">存档参数配置</p>

          <!-- form表单 -->
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="10.0rem"
            class="demo-ruleForm"
          >
            <el-form-item label="企业全称" prop="companyName">
              <el-input
                clearable
                v-model="ruleForm.companyName"
                placeholder="请输入企业全称"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业ID" prop="companyId">
              <el-input
                clearable
                v-model="ruleForm.companyId"
                placeholder="请输入企业ID"
              ></el-input>
            </el-form-item>
            <div class="showInformation">
              <p class="title">配置企业全称和ID</p>
              <p>
                进入
                <span style="color: #67c0ff">企业微信</span>
                打开【我的企业】，将企业全称和ID分别复制并填写到下方输入框中
                <span
                  style="color: #67c0ff; cursor: pointer"
                  @click="onSubmit = true"
                  >配置教程</span
                >
              </p>
            </div>
            <div class="showInformation">
              <p class="title">配置可见范围</p>
              <p>
                进入
                <span style="color: #67c0ff">企业微信</span>
                打开【管理工具】 -进入【会话内容存档】
                -开启范围，配置成员。设置后，可获取开启范围中成员的会话内容，必须在企业微信中配置完成，否则应用将无法获取会话内容
                <span
                  style="color: #67c0ff; cursor: pointer"
                  @click="onSubmit1 = true"
                  >配置教程</span
                >
              </p>
            </div>
            <el-form-item label="IP地址1">
              <el-input
                :readonly="true"
                id="serverIp"
                v-model="ipve"
                placeholder="服务器IP"
              ></el-input>
              <span class="copy" @click="copyValue('serverIp')">复制</span>
            </el-form-item>
            <div class="showInformation">
              <p class="title">配置可信IP地址</p>
              <p>
                进入
                <span style="color: #67c0ff">企业微信</span>
                打开【管理工具】
                -进入【会话内容存档】-可信IP地址添加。将下方IP地址逐一复制并添加到企业微信-可信IP地址中
                <span
                  style="color: #67c0ff; cursor: pointer"
                  @click="onSubmit2 = true"
                  >配置教程</span
                >
              </p>
            </div>
            <el-form-item label="消息加密公钥" class="privateKey">
              <el-input
                :readonly="true"
                type="textarea"
                autosize="true"
                id="privateKey"
                placeholder="公钥内容"
                v-model="publicContent"
              ></el-input>
              <p class="update" @click="updatePublicKey">更新公钥</p>
              <p class="copySsr" @click="copyValue('privateKey')">复制</p>
            </el-form-item>
            <div class="showInformation">
              <p class="title">配置消息加密公钥</p>
              <p>
                进入
                <span style="color: #67c0ff">企业微信</span>
                打开【管理工具】-进入【会话内容存档】
                -消息加密公钥-设置。将下方消息加密公钥信息复制并添加到企业微信-消息加密公钥-设置中如果在企业微信中已经设置过公钥信息，请点击下方【更新公钥】按钮进行公钥更新，并把最新的公钥信息复制并添加到企业微信-消息加密公钥-设置中
                <span
                  style="color: #67c0ff; cursor: pointer"
                  @click="onSubmit3 = true"
                  >配置教程</span
                >
              </p>
            </div>
            <el-form-item label="消息加密私钥">
              <el-input
                :readonly="true"
                :placeholder="placeholderText"
                v-model="privateContent"
              ></el-input>
            </el-form-item>
            <el-form-item label="公钥版本号" prop="version">
              <el-input
                clearable
                v-model="ruleForm.version"
                placeholder="请输入消息加密公钥版本号"
              ></el-input>
            </el-form-item>
            <div class="showInformation">
              <p class="title">配置公钥版本号</p>
              <p>
                进入
                <span style="color: #67c0ff">企业微信</span>
                打开【管理工具】 -进入【会话内容存档】
                -消息加密公钥-版本号。将版本号复制并填写到下方输入框中，如果消息加密公钥有更新，请将更新后的版本号重新复制更新到下方输入框中
                <span
                  style="color: #67c0ff; cursor: pointer"
                  @click="onSubmit4 = true"
                  >配置教程</span
                >
              </p>
            </div>
            <el-form-item label="会话密钥Secret" prop="sessionKey">
              <el-input
                clearable
                v-model="ruleForm.sessionKey"
                placeholder="会话秘钥Secret"
              ></el-input>
            </el-form-item>
            <div class="showInformation">
              <p class="title">配置会话密钥Secret</p>
              <p>
                进入
                <span style="color: #67c0ff">企业微信</span>
                打开【管理工具】 -进入【会话内容存档】 -Secret。
                将会话Secret复制并填写到输入框中，如果会话Secret有更新，请将更新后的会话Secret重新复制更新到下方的输入框中
                <span
                  style="color: #67c0ff; cursor: pointer"
                  @click="onSubmit5 = true"
                  >配置教程</span
                >
              </p>
            </div>
            <el-form-item label="外部联系人密钥Secret" prop="relativeKey">
              <el-input
                clearable
                v-model="ruleForm.relativeKey"
                placeholder="请输入外部联系人Secret"
              ></el-input>
            </el-form-item>

            <div class="showInformation">
              <p class="title">配置外部联系人密钥Secret</p>
              <p>
                进入
                <span style="color: #67c0ff">企业微信</span>
                打开【客户联系】 -选择【客户】 -展开右侧【API】 -Secret。
                将外部联人秘钥Secret重新复制更新到下方输入框中
                <span
                  style="color: #67c0ff; cursor: pointer"
                  @click="onSubmit6 = true"
                  >配置教程</span
                >
              </p>
            </div>
          </el-form>
          <span class="nextStep" @click="nextStep('ruleForm')">下一步</span>
        </div>
        <!-- 介绍表单展示信息 -->
        <div class="formIntroduce"></div>
      </div>
    </div>
    <div
      :class="ines == true ? 'gain' : 'no_gain'"
      style="background: rgb(245, 247, 250); padding: 5.0rem"
    >
      <div>
        <div style="width: 100%">
          <h2 style="text-align: center; :font-family: 900">
            为保证正常体验会话内容存档全部功能，请先完成以下配置后使用，在配置过程中遇到问题可以联系客服
          </h2>
        </div>
        <div class="body_aun">
          <div>
            <div>
              <h2 style="color: rgb(107, 104, 101)">接收事件服务器配置</h2>
            </div>
            <div class="noneboy">
              <h3>8.接收事件服务器URL配置</h3>
              <p class="nobn">
                进入&nbsp;&nbsp;
                <span>企业微信</span
                >&nbsp;&nbsp;打开【客户联系】-选择【客户】-展开右侧【API】-接收事件服务器-编辑/设置&nbsp;&nbsp;
                <span
                  style="color: #67c0ff; cursor: pointer"
                  @click="onSubmit7 = true"
                  >配置教程</span
                >&nbsp;&nbsp;
              </p>
              <ul class="bboss">
                <li>
                  <p>
                    ●第一步:将下方URL复制并添加到企业微信接收事件服务器编辑/设置-URL中
                  </p>
                </li>
                <li>
                  <p>
                    ●第二步:点击随机获取按钮，将获取Token复制并填写到下方Token输入框中。如果后续Token有更新，请重新进行复制，确保系统中配置中的Token与企业微信中Token保持一
                    致
                  </p>
                </li>
                <li>
                  <p>●第三步:点击随机获取按钮，将获取</p>
                </li>
                <li style="color: red">
                  <p>
                    ●第四步:必须先点击下方的[配置完成，开启使用]按钮，然后回到企业微信点击[保存]按钮，企业微信中会出现保存成功的提示
                  </p>
                </li>
              </ul>
            </div>
            <div class="nnn">
              <el-form
                :model="ruleFormn"
                :rules="rules"
                ref="ruleFormn"
                label-width="20.0rem"
                label-position="left"
                class="demo-ruleForm"
              >
                <el-form-item label="url" style="width: 79%">
                  <el-input
                    id="serverIpvv"
                    :readonly="true"
                    v-model="ruleFormn.url"
                    placeholder="serverIp"
                  ></el-input>
                  <span class="copy" @click="copyValue('serverIpvv')"
                    >复制</span
                  >
                </el-form-item>
                <el-form-item label="Token">
                  <el-input
                    clearable
                    v-model="ruleForm.token"
                    placeholder="请输入Token值"
                  ></el-input>
                </el-form-item>
                <el-form-item label="EncodingAESKey">
                  <el-input
                    clearable
                    v-model="ruleForm.encodingAesKey"
                    placeholder="请输入EncodingAESKey值"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="submitForm('ruleFormn')"
                    >配置完成，开启会话存档</el-button
                  >
                  <el-button @click="resetForm()">返回上一步配置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="配置教程" center  :visible.sync="onSubmit" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/1.png" alt />
      </div>
    </el-dialog>

    <el-dialog title="配置教程" center :visible.sync="onSubmit1" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/2.png" alt />
      </div>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit2" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/3.png" alt />
      </div>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit3" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/4.png" alt />
      </div>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit4" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/5.png" alt />
      </div>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit5" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/6.png" alt />
      </div>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit6" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/7.png" alt />
      </div>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit7" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/8.png" alt />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "setCompanyInformation",
  data() {
    return {
      onSubmit: false,
      onSubmit1: false,
      onSubmit2: false,
      onSubmit3: false,
      onSubmit4: false,
      onSubmit5: false,
      onSubmit6: false,
      onSubmit7: false,
      textarea: "",
      privateAddress: "",
      encodingAesKey: "",
      // 私钥地址
      privatekey_url: "",
      // 公钥地址
      publickey_url: "",
      account_id: Number,
      phone: Number,
      token: "",
      placeholderText: "当前内容不可见",
      publicContent: "",
      baseURL: this.axios.defaults.baseURL,
      privateContent: "",
      tooken: "",
      ruleForm: {
        companyName: "",
        companyId: "",
        version: "",
        sessionKey: "",
        relativeKey: "",
      },
      jiaoyan: "",
      chongg: "",
      shibai: "",
      ruleFormn: {
        url: "",
      },
      bianll: false,

      ines: true,
      ipve: "",
      rules: {
        companyName: [
          { required: true, message: "请输入企业全称", trigger: "blur" },
          {
            min: 2,
            max: 35,
            message: "长度在 2 到 35 个字符",
            trigger: "blur",
          },
        ],
        companyId: [
          { required: true, message: "请输入企业ID", trigger: "blur" },
        ],
        version: [
          {
            required: true,
            message: "请输入消息加密公钥版本号",
            trigger: "blur",
          },
        ],
        sessionKey: [
          {
            required: true,
            message: "请输入会话秘钥Secret",
            trigger: "blur",
          },
        ],
        relativeKey: [
          {
            required: true,
            message: "请输入外部联系人Secret",
            trigger: "blur",
          },
        ],
        encodingAesKey: [
          {
            required: true,
            message: "请输入aes_key值",
            trigger: "blur",
          },
        ],
        token: [
          {
            required: true,
            message: "请输入token值",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 返回上一步
    resetForm() {
      this.bianll = false;
      this.ines = true;
    },
    // 配置完成开启会话存档
    submitForm() {
      this.setCompanyInformations();
    },
    // 更新公钥
    updatePublicKey() {
      this.axios({
        method: "post",
        url: `${this.baseURL}/home/AccountInfo/getKey`,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: qs.stringify({
          account_id: this.account_id,
          phone: this.phone,
          usertoken: this.tooken,
        }),
      })
        .then((res) => {
          this.publicContent = res.data.data.pubKey;
          this.ipve = res.data.data.serverip;
        })
        .catch((err) => {});
    },
    // 复制功能的实现
    copyValue(value) {
      let theValue = document.getElementById(value);
      theValue.select();
      document.execCommand("Copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },

    // 点击下一步实现
    nextStep(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleFormn.url =
            "https://api.weijub.com/home/Callback/notify?corpid=" +
            this.ruleForm.companyId;
          this.bianll = true;
          this.ines = false;
        } else {
          return false;
        }
      });
      if (!this.publicContent) {
        this.$message({
          message: "请输入消息加密公钥",
          type: "warning",
        });
      }
    },
    // 发送请求设置企业信息
    setCompanyInformations() {
      // 设置企业信息时获取用户输入的所有的企业信息
      // 企业全称
      this.ruleForm.companyName = this.ruleForm.companyName.trim();
      // 企业id
      this.ruleForm.companyId = this.ruleForm.companyId.trim();
      // IP地址1
      this.ruleForm.companyAdress = this.ruleForm.companyAdress.trim();
      // 公钥版本号
      this.ruleForm.version = this.ruleForm.version.trim();
      // 会话秘钥
      this.ruleForm.sessionKey = this.ruleForm.sessionKey.trim();
      // 外部联系人秘钥
      this.ruleForm.relativeKey = this.ruleForm.relativeKey.trim();
      // aes_key值
      this.ruleForm.encodingAesKey = this.ruleForm.encodingAesKey.trim();
      // token
      this.ruleForm.token = this.ruleForm.token.trim();
      // 发送请求，设置企业信息
      this.axios({
        method: "post",
        url: `${this.baseURL}/home/AccountInfo/editAddAccountInfo`,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: qs.stringify({
          usertoken: this.tooken,
          account_id: this.account_id,
          account_name: this.ruleForm.companyName,
          account_corpid: this.ruleForm.companyId,
          privkey: this.privatekey_url,
          publickey_ver: this.ruleForm.version,
          secret: this.ruleForm.sessionKey,
          cus_secret: this.ruleForm.relativeKey,
          encodingAesKey: this.ruleForm.encodingAesKey,
          token: this.ruleForm.token,
          pubKey: this.publicContent,
          phone: this.phone,
        }),
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.jiaoyan = res.data.code;
            this.chongg = res.data.msg;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$router.push("/register/user/param");
          } else if (res.data.code == 0) {
            this.jiaoyan = res.data.code;
            this.shibai = res.data.msg;
            this.$message({
              message: res.data.msg,
              type: "error",
            });

            // return
          }
          // 提示修改成功
        })
        .catch((err) => {});
    },
  },
  created() {
    // 获取请求信息
    let localStorage = window.localStorage;
    this.account_id = localStorage.getItem("account_id");
    this.phone = localStorage.getItem("phone");
    // 获取当前请求ip
    this.ruleForm.companyAdress = this.baseURL.split("/")[
      this.baseURL.split("/").length - 1
    ];
    // 获取token值
    this.tooken = window.localStorage.getItem("usertoken");
    // 获取登录的用户的id以及用户电话号码（账号）
    // 获取消息加密公钥内容以及密钥地址
    this.axios({
      method: "post",
      url: `${this.baseURL}/home/AccountInfo/getKey`,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: qs.stringify({
        account_id: this.account_id,
        phone: this.phone,
        usertoken: this.tooken,
      }),
    })
      .then((res) => {
        this.publicContent = res.data.data.pubKey;
        this.privatekey_url = res.data.data.privkey;
        this.ipve = res.data.data.serverip;
      })
      .catch((err) => {});
  },
};
</script>

<style scoped>
.setCompanyInformation {
  width: 100%;
  height: 100%;
}
.inforHead {
  width: 100%;
  height: 112px;
  background: #0069b3;
}
.inforLogo {
  width: 8.0rem;
  display: inline-block;
  text-align: center;
  margin: 13px 0 0 18px;
}
.inforText {
  width: 1742px;
  height: 100%;
  display: inline-block;
  text-align: center;
}
.topLogo {
  width: 7.0rem;
  height: 39px;
  margin: 0 auto;
  background-image: url("../../../src/assets/微炬logo图标.png");
  margin-bottom: 8px;
}
.bottomLogo {
  width: 76px;
  height: 37px;
  margin: 0 auto;
  background-image: url("../../../src/assets/图层.png");
}
.onlyOneStep {
  color: #ffffff;
  font-size: 24px;
  margin-bottom: 2.0rem;
}
.detail {
  color: #ffffff;
  font-size: 2.0rem;
}
.setContent {
  width: 100%;
  height: 190.0rem;
  background: url("../../assets/backgroundInfo.png") center no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.archiveParams {
  width: 60.0rem;
  /* margin-right: 18px; */
  padding-top: 3.0rem;
  margin: 0 auto;
}
.formIntroduce {
  width: 942px;
  margin-left: 18px;
  margin-top: 34px;
  color: #ffffff;
}
.formIntroduce span {
  cursor: pointer;
}
.archiveTitle {
  font-size: 24px;
  color: #ffffff;
  width: 100%;
  text-align: left;
}
.copy {
  position: absolute;
  right: -7.0rem;
  color: #3088db;
  font-size: 16px;
  cursor: pointer;
}
.copySsr {
  position: absolute;
  top: 5.0rem;
  right: -7.0rem;
  color: #3088db;
  font-size: 16px;
  cursor: pointer;
}
.update {
  width: 92px;
  height: 32px;
  background: #3088db;
  text-align: center;
  line-height: 32px;
  color: #ffffff;
  font-size: 16px;
  border-radius: 4px;
  position: absolute;
  top: 15px;
  right: -11.0rem;
  cursor: pointer;
}
.nextStep {
  width: 112px;
  height: 47px;
  display: inline-block;
  background: #3088db;
  position: absolute;
  bottom: 20.0rem;
  left: 93.0rem;
  text-align: center;
  line-height: 47px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 2.0rem;
  cursor: pointer;
}
.title {
  font-size: 18px;
  font-weight: bold;
}
.showInformation {
  /* margin: 1.0rem 0; */
  width: 80%;
  font-size: 18px;
  color: #ffffff;
  margin-left: 10.0rem;
  margin-top: 1.0rem;
  margin-bottom: 1.0rem;
}
.gain {
  display: none;
}
.on_gain {
  display: block;
}
.body_aun {
  width: 90%;
  height: 75.0rem;
  /* background-color: black; */
  /* border: 1px solid rgb(229,229,229); */
  background-color: #ffffff;
  padding: 3.0rem;
  margin: 2.0rem auto;
}
.body_aun > div {
  width: 80%;
  height: 90%;
  margin: 3.0rem auto;
  border: 1px solid rgb(229, 229, 229);
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}
.noneboy {
  width: 100%;
  /* height: 10.0rem; */
  background-color: rgb(237, 245, 252);
  margin-top: 2.0rem;
  padding: 2.0rem;
}
.noneboy > h3 {
  margin-top: 2.0rem;
}
.nobn {
  margin-top: 1.0rem;
}
.bboss {
  margin-top: 1.0rem;
}
.bboss > li {
  margin-top: 1.0rem;
}
.nnn {
  /* margin-top: 2.0rem; */
  width: 90%;
  margin: 2.0rem auto;
}
</style>
